export class Dropdown {
    constructor(dropdown, BEM_BLOCK = 'filter-dropdown') {
        this.dropdown = dropdown;
        this.OPEN_SELECTOR = `${BEM_BLOCK}--open`;

        this.title = this.dropdown.querySelector(`.${BEM_BLOCK}__title`);
        this.options = this.dropdown.querySelector(`.${BEM_BLOCK}__options`);
        this.form = null;

        this.DEAFULT_TITLE = null;
        this.activeLabels = [];

        this.init();
    }

    init() {
        this.setDefaultTitleText();
        this.initActiveLabels();
        this.initHandlers();
    }

    initHandlers() {
        this.title.addEventListener('click', () => this.checkState());
    }

    // Для того, чтобы стандартный бутстраповский слайдер,
    // внутри которого лежит дропдаун не считал его высоту
    checkState() {
        if (this.dropdown.classList.contains(this.OPEN_SELECTOR)) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.options.style.display = 'block';

        setTimeout(() => {
            this.dropdown.classList.add(this.OPEN_SELECTOR);
            document.addEventListener('click', this.missclickHandler);
        }, 0);
    }

    close() {
        this.dropdown.classList.remove(this.OPEN_SELECTOR);
        this.options.addEventListener('transitionend', this.transitionHandler);
        document.removeEventListener('click', this.missclickHandler);
    }

    transitionHandler = () => {
        this.options.style.display = 'none';
        this.options.removeEventListener('transitionend', this.transitionHandler);
    };

    missclickHandler = (evt) => {
        const isClickInside = this.options.contains(evt.target);

        if (!isClickInside && window.outerWidth > 576) {
            this.close();
        }
    };

    initActiveLabels() {
        const items = Array.from(this.options.querySelectorAll('[class$="-input__input"]')); // и чек-боксы, и радокнопки

        items.forEach((item) => {
            const textElement = item.parentElement.querySelector('[class$="-input__label"]'); // ближайжий класс с текстовым описанием
            if (!textElement) return;

            item.addEventListener('change', (evt) => {
                this.rewriteActiveLabels(textElement, evt);
                this.setSelectorText();
            });

            if (item.checked) {
                this.rewriteActiveLabels(textElement);
                this.setSelectorText();
            }

            this.form = item.form;
        });

        if (this.form) {
            this.form.addEventListener('reset', () => {
                this.activeLabels = [];
                this.setSelectorText();
            });
        }
    }

    setDefaultTitleText() {
        const titleText = this.title.querySelector('.filter-dropdown__text');
        if (!titleText) return;

        this.DEAFULT_TITLE = titleText.textContent;
    }

    /**
     * Прописывает в заголовок выпадашки выбранные элементы
     * Если это радиокнопка -- то просто переписывет, а не добавляет
     *
     * @param {string} textElement - заголовок выбранного элемента
     * @param {Event} evt
     */
    rewriteActiveLabels = (textElement, evt = null) => {
        const text = textElement.textContent;
        const type = evt ? evt.target.type : null;

        if (type && type === 'radio') {
            this.activeLabels = [text];
            this.close();
            return;
        }

        if (this.activeLabels.includes(text)) {
            this.activeLabels = this.activeLabels.filter((label) => label !== text);
        } else {
            this.activeLabels.push(text);
        }
    };

    setSelectorText() {
        const titleText = this.title.querySelector('.filter-dropdown__text');
        if (!titleText) return;

        titleText.textContent = this.activeLabels.length > 0 ? this.activeLabels.join(', ') : this.DEAFULT_TITLE;
    }
}
